// extracted by mini-css-extract-plugin
export default {"zoomControls":"ZoomControls_zoomControls__YW8-g","zoomBtn":"ZoomControls_zoomBtn__5b3+z"};